<template>
  <div class="page-wrap" v-show="isShow" @click.self="hide();$emit('cancel')">
    <transition name="page-move">
      <div class="filter-wrap">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>

export default {
  name: 'ListSearchForm',
  data () {
    return {
      isShow: false,
      bodyScrollTop: 0
    }
  },
  methods: {
    show() {
      // 保存当前滚动位置
      this.bodyScrollTop = document.documentElement.scrollTop || document.body.scrollTop
      // 阻止背景页面滚动
      document.body.style.position = 'fixed'
      document.body.style.top = `-${this.bodyScrollTop}px`
      document.body.style.width = '100%'

      this.isShow = true
    },
    hide() {
      this.isShow = false

      // 恢复背景页面滚动
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.width = ''
      // 恢复滚动位置
      document.documentElement.scrollTop = this.bodyScrollTop
      document.body.scrollTop = this.bodyScrollTop
    }
  }
}
</script>

<style lang="stylus" scoped>
.page-wrap{
        position :fixed;
        width :100%;
        height :100%;
        top: 0;
        left: 0;
        background: rgba(0,0,0,.6);
        z-index :91;
    }

    .filter-wrap{
        width: 70%;
        height: 100vh;
        height: 100dvh; // 动态视口高度，排除浏览器 UI
        background: #fff;
        transition: transform .3s;
        position: absolute;
        right: 0;
        top: 0;
        overflow: hidden;
        overscroll-behavior: contain;
        -webkit-overflow-scrolling: touch;
    }

    // 过渡效果
    .page-move-enter, .page-move-leave-active{
        transform: translate(100%, 0%)
    }

    .page-move-enter-active, .page-move-leave-active{
        transition: transform .6s
    }

</style>
